import React, { useState } from 'react';
import { useEffect } from 'react';
import { Form, Input, Button, Dropdown } from 'semantic-ui-react';
import { useProposals } from '../../../../providers/ProposalProvider';
import { useProducts } from '../../../../providers/ProductProvider';

export const ProposalFormRow = ({ index, id, data, disabled }) => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [totalPrice, setTotalPrice] = useState();
    const { dropdownProductData, getProductById } = useProducts();
    const { updateRow, removeRow } = useProposals();

    useEffect(() => {
        if (data?.quantity) {
            setQuantity(data.quantity);
        }
        if (data?.productId) {
            setSelectedProduct(data.product);
        }
    }, [data]);

    useEffect(() => {
        if (selectedProduct?.price) {
            setTotalPrice(parseFloat(selectedProduct.price * quantity).toFixed(2));
        } else {
            setTotalPrice();
        }
    }, [quantity, selectedProduct]);

    return (
        <Form.Group widths={'equal'} key={index}>
            {disabled ? (
                <Form.Field
                    key={`product${id}`}
                    readOnly={true}
                    label={index === 0 ? 'Product' : ''}
                    control={Input}
                    defaultValue={data?.product?.name}
                    style={{ height: '38px' }}
                    width="3"
                />
            ) : (
                <Form.Field
                    key={`product${id}`}
                    readOnly={true}
                    label={index === 0 ? 'Product' : ''}
                    control={Dropdown}
                    fluid
                    selection
                    defaultValue={data?.productId}
                    options={
                        disabled
                            ? [
                                {
                                    key: data?.productId,
                                    text: data?.product.name,
                                    value: data?.productId,
                                },
                            ]
                            : dropdownProductData.filter(product => product.enabled === 'true')
                    }
                    style={{ height: '38px' }}
                    onChange={(e, selected) => {
                        setSelectedProduct(getProductById(selected.value));
                        updateRow(index, selected.value, quantity);
                    }}
                    width="3"
                    search
                />
            )}
            <Form.Field
                key={`quantity${id}`}
                disabled={!selectedProduct}
                label={index === 0 ? 'Quantity' : ''}
                readOnly={disabled}
                control={Input}
                value={quantity}
                onChange={(e, quantity) => {
                    if (quantity.value === '') {
                        setQuantity('');
                        return;
                    }
                    const quantityNum = parseInt(quantity.value);
                    if (quantityNum > 0) {
                        setQuantity(quantityNum);
                        updateRow(index, selectedProduct.id, quantityNum);
                    }
                }}
                type={'number'}
                width="1"
            />
            <Form.Field
                key={`price${id}`}
                disabled={!selectedProduct}
                readOnly={true}
                label={index === 0 ? 'List Price Each' : ''}
                control={Input}
                type={'number'}
                icon={'dollar'}
                value={selectedProduct?.price ? parseFloat(selectedProduct.price).toFixed(2) : 0}
                iconPosition={'left'}
                width="2"
            />
            <Form.Field
                key={`total${id}`}
                disabled={!selectedProduct}
                readOnly={true}
                label={index === 0 ? 'List Price Total' : ''}
                control={Input}
                type={'number'}
                icon={'dollar'}
                value={totalPrice ? totalPrice : 0}
                iconPosition={'left'}
                width="2"
            />
            <Button
                style={{ height: '38px', alignSelf: 'flex-end' }}
                disabled={disabled}
                icon={'remove'}
                onClick={() => {
                    setTotalPrice(0);
                    removeRow(index);
                }}
            />
        </Form.Group>
    );
};
